import React, { useEffect, useState } from 'react';
import './FloatContactButton.css';

function FloatContactButton() {
  const [open, setOpen] = useState(false);
  const [showNumber, setShowNumber] = useState(false);
  const [showApollo, setShowApollo] = useState(false);
  const phoneNumber = ' (+52) 33 1543 4005';

  useEffect(() => {
    if (!open) {
      setShowNumber(false);
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://use.fontawesome.com/releases/v7.1.0/css/all.css';
    document.head.appendChild(link);
    setShowApollo(false);
  }, [open]);

  return (
    <>
      {open && (
        <div className={`float-contact-options ${open ? 'show' : ''}`}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button className="float-contact-phone" onClick={() => setShowNumber((prev) => !prev)}>
              <i
                className="fa-solid fa-phone-volume"
                style={{ marginRight: '4px', color: '#c70808' }}
              ></i>
              <span className="float-contact-label"> Llamar</span>
            </button>
            <a
              href="https://wa.me/523333033677"
              target="_blank"
              rel="noopener noreferrer"
              className="float-contact-option"
            >
              <i className="fa-brands fa-whatsapp" style={{ marginRight: '4px' }}></i>
              WhatsApp
            </a>
          </div>
        </div>
      )}
      {/* Popup flotante único para ayuda o número */}
      <div className={`float-contact-number-popup${showApollo || showNumber ? ' show' : ''}`}>
        {showApollo && !open ? (
          <div className="float-contact-tooltip">
            <span>¿Necesitas ayuda?</span>
            <span>¡Contáctanos!</span>
          </div>
        ) : showNumber ? (
          <div className="float-contact-number">{phoneNumber}</div>
        ) : null}
      </div>
      <button
        className="float-contact-btn"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Contacto"
        onMouseEnter={() => setShowApollo(true)}
        onMouseLeave={() => setShowApollo(false)}
      >
        {open ? <span>✖</span> : <i className="fa-solid fa-headset"></i>}
      </button>
    </>
  );
}

export default FloatContactButton;
